import { render, staticRenderFns } from "./TabelaDeRecebimentos.vue?vue&type=template&id=85b759ce&scoped=true"
import script from "./TabelaDeRecebimentos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeRecebimentos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeRecebimentos.vue?vue&type=style&index=0&id=85b759ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b759ce",
  null
  
)

export default component.exports